import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsortiumListComponent } from './consortium-list/consortium-list.component';
import { ConsortiumFormComponent } from './consortium-form/consortium-form.component';
import { ConsortiumRoutingModule } from './consortium-routing.module';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ConsortiumListComponent,
    ConsortiumFormComponent
  ],
  imports: [
    CommonModule,
    ConsortiumRoutingModule,
    AngularMaterialModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class ConsortiumModule { }
